import { render } from "./DNARelationNetwork.vue?vue&type=template&id=989bb3fe"
import script from "./DNARelationNetwork.vue?vue&type=script&lang=js"
export * from "./DNARelationNetwork.vue?vue&type=script&lang=js"

import "./DNARelationNetwork.vue?vue&type=style&index=0&id=989bb3fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__